
import styles from './AccountSettingsView.module.css';
import React from 'react';
import Button from '../components/Button';

class AccountSettingsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {user: "pepega"};
    this.unlinkSpotifyAccount = this.unlinkSpotifyAccount.bind(this);
  }

  fetchUserData() {
    console.log("fetchUserData was called");
    const requestOptions = {
      method: 'GET',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'user/me', requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      console.log(response);
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("LOGGED IN AS:");
      this.setState({user: data});
      console.log(data);

      this.forceUpdate();
      this.render();
    });
  }


  logoutUser(e){
    console.log("USER HAS BEEN LOGGED OUT")
    localStorage.removeItem("user_token");
    window.location.href = `/`; 
  }

  linkSpotifyAccount(e){

    window.location.href = `https://accounts.spotify.com/en/authorize?client_id=1dd0d3689eb342ab8fdfec1bde230f5f&response_type=code&redirect_uri=${process.env.REACT_APP_SPOTIFY_REDIRECTURI}&scope=playlist-modify-public%20ugc-image-upload%20playlist-modify-private`; 
  }


  async unlinkSpotifyAccount(e){

    console.log("INSIDE UNLINKSPOTIFYACCOUNT");
    console.log(this);

    const requestOptions = {
      method: 'DELETE',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };

    await fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'user/spotify', requestOptions)
    .then(response => {
      if(response.status === 500)
      {
        console.log("Something went wrong during this request");
        alert(response.body);
      }
      else if(response.status === 400)
      {
        response.json().then(data => {
          alert(data.status);
        });
      }
      return response;
    })

    this.fetchUserData();

  }


  componentDidMount(){
    console.log("componentdidmount was called");
    console.log(this);
    this.fetchUserData();
  }

  render(){
    console.log(this.state.user);
    if(this.state.user === undefined || this.state.user === "pepega") return null;

    var discordAvatarString = `https://cdn.discordapp.com/avatars/${this.state.user.id}/${this.state.user.avatar}.png?size=256`;

    var spotifydetails = "";
    if(this.state.user.spotify != null)
    {
      spotifydetails = <div><div class="divA">
          <img src={this.state.user.spotify.avatar} class={styles.avatar} alt="avatar"></img>
        </div>
        <div class="divB">
          <span>{this.state.user.spotify.username}</span>
            <Button dangerous onClick={this.unlinkSpotifyAccount}>Unlink</Button>
        </div>
      </div>
    }
    else
    {
      spotifydetails = <div>
        <div class="divA">
          <span>No spotify account linked.</span>
        </div>
        <div class="divB">
          <Button primary onClick={this.linkSpotifyAccount}>Link</Button>
        </div>
      </div>
    }

    return <div>
      <div class={styles.account}>
        <h2>Discord Account</h2>
        <div class="divA">
          <img src={discordAvatarString} class={styles.avatar} alt="avatar"></img>
        </div>
        <div class="divB">
        <span>{this.state.user.username}#{this.state.user.discriminator}</span>
          <Button dangerous onClick={this.logoutUser}>Logout</Button>
        </div>
      </div>

      <div class={styles.account}>
        <h2>Spotify Account</h2>
          {spotifydetails}
      </div>
    </div>;
  }





}





export default AccountSettingsView;
